var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1336 15.4183C6.91175 15.4183 6.69899 15.3302 6.54212 15.1733C6.38525 15.0165 6.29712 14.8037 6.29712 14.5818V-0.876405C6.29712 -1.09826 6.38525 -1.31102 6.54212 -1.46789C6.69899 -1.62476 6.91175 -1.71289 7.1336 -1.71289C7.35545 -1.71289 7.56822 -1.62476 7.72509 -1.46789C7.88196 -1.31102 7.97009 -1.09826 7.97009 -0.876405V14.5818C7.97009 14.8037 7.88196 15.0165 7.72509 15.1733C7.56822 15.3302 7.35545 15.4183 7.1336 15.4183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8628 7.68957H-0.5954C-0.817249 7.68957 -1.03001 7.60144 -1.18688 7.44457C-1.34376 7.2877 -1.43188 7.07494 -1.43188 6.85309C-1.43188 6.63124 -1.34376 6.41847 -1.18688 6.2616C-1.03001 6.10473 -0.817249 6.0166 -0.5954 6.0166H14.8628C15.0847 6.0166 15.2975 6.10473 15.4543 6.2616C15.6112 6.41847 15.6993 6.63124 15.6993 6.85309C15.6993 7.07494 15.6112 7.2877 15.4543 7.44457C15.2975 7.60144 15.0847 7.68957 14.8628 7.68957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3496,
    height: 13.3496,
    fill: "white",
    transform: "translate(0.458984 0.177734)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8852e1f0193d026753fd113023f4bbcf.svg";
export { ForwardRef as ReactComponent };